import './customerEdit.css'
import { useParams } from "react-router-dom";
import { useGetUserQuery, useUpdateUserMutation } from '../../services/userCRUDApi';
import { House, Signpost, LocationCity, CalendarToday, BadgeOutlined, LocationSearching, MailOutline, PhoneAndroid, PersonOutline } from "@mui/icons-material";
import user_image from "../profile/UserAfatar.jpg";
import { useState, useEffect } from "react";
import { AdminPageHeader, AdminCard, AdminInput, AdminSelect, LoadingButton, AdminSkeleton, AdminEmptyState, useToast } from '../../components/ui'
import { formatDateTimeIso } from '../../utils/format'

function CustomerEdit() {
  const { id } = useParams()
  const responseData = useGetUserQuery(id)
  const [data, setData] = useState(null);
  const [server_error, setServerError] = useState({});
  const [updateUser, { isLoading }] = useUpdateUserMutation();
  const toast = useToast();

  useEffect(() => {
    if (responseData.isSuccess) {
      setData({
        id: responseData.data.id,
        type: responseData.data.type,
        first_Name: responseData.data.first_Name,
        last_Name: responseData.data.last_Name,
        phone_Number: responseData.data.phone_Number,
        data_Joind: responseData.data.data_Joind,
        email: responseData.data.email,
        last_login: responseData.data.last_login,
        house_Number: responseData.data.address?.house_Number,
        street_Number: responseData.data.address?.street_Number,
        city: responseData.data.address?.city,
        area: responseData.data.address?.area,
      })
    }
  }, [responseData])

  const handleChange = event => {
    const name = event.target.name;
    const value = event.target.value;
    setData(values => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const actualData = {
      id: data.id,
      first_Name: data.first_Name,
      last_Name: data.last_Name,
      phone_Number: data.phone_Number,
      address_Id: responseData.data.address?.address_Id,
      address: {
        house_Number: data.house_Number,
        street_Number: data.street_Number,
        city: data.city,
        area: data.area,
      }
    };
    const res = await updateUser(actualData);
    if (res.error) {
      setServerError(res.error.data?.errors || {});
      toast.error("Could not update this profile. Check the fields below.");
    }
    if (res.data) {
      setServerError({})
      toast.success("Profile updated successfully.");
    }
  };

  const breadcrumbs = [{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Users" }];

  if (responseData.isLoading || !data) {
    return (
      <div>
        <AdminPageHeader title="User Profile" breadcrumbs={breadcrumbs} />
        <AdminCard><AdminSkeleton variant="card" height={240} /></AdminCard>
      </div>
    );
  }

  if (responseData.isError) {
    return (
      <div>
        <AdminPageHeader title="User Profile" breadcrumbs={breadcrumbs} />
        <AdminEmptyState icon={<PersonOutline />} title="Couldn't load this user" description="Something went wrong. Try refreshing the page." />
      </div>
    );
  }

  return (
    <div>
      <AdminPageHeader title="User Profile" breadcrumbs={breadcrumbs} />
      <div className="customerEditLayout">
        <AdminCard className="userShow">
          <div className="userShowTop">
            <img src={user_image} alt="" className="userShowImg" />
            <div className="userShowTopTitle">
              <span className="userShowUsername">{(data.first_Name || data.last_Name) ? `${data.first_Name || ""} ${data.last_Name || ""}`.trim() : data.email}</span>
            </div>
          </div>
          <div className="userShowBottom">
            <span className="userShowTitle">Account Details</span>
            <div className="userShowInfo">
              <div><BadgeOutlined /><span>User ID</span></div>
              <div><span>{data.id}</span></div>
            </div>
            <div className="userShowInfo">
              <div><CalendarToday /><span>Account Created</span></div>
              <div><span>{formatDateTimeIso(data.data_Joind)}</span></div>
            </div>
            <div className="userShowInfo">
              <div><CalendarToday /><span>Last Login</span></div>
              <div><span>{formatDateTimeIso(data.last_login)}</span></div>
            </div>
            <span className="userShowTitle">Contact Details</span>
            <div className="userShowInfo">
              <div><PhoneAndroid /><span>Phone</span></div>
              <div><span>{data.phone_Number || "—"}</span></div>
            </div>
            <div className="userShowInfo">
              <div><MailOutline /><span>Email</span></div>
              <div><span>{data.email || "—"}</span></div>
            </div>
            <span className="userShowTitle">Address</span>
            <div className="userShowInfo">
              <div><House /><span>House Number</span></div>
              <div><span>{data.house_Number || "—"}</span></div>
            </div>
            <div className="userShowInfo">
              <div><Signpost /><span>Street Number</span></div>
              <div><span>{data.street_Number || "—"}</span></div>
            </div>
            <div className="userShowInfo">
              <div><LocationSearching /><span>Area</span></div>
              <div><span>{data.area || "—"}</span></div>
            </div>
            <div className="userShowInfo">
              <div><LocationCity /><span>City</span></div>
              <div><span>{data.city || "—"}</span></div>
            </div>
          </div>
        </AdminCard>

        {data.type === "CUSTOMER" ? (
          <AdminCard className="userUpdate">
            <span className="userUpdateTitle">Edit</span>
            <p className="userUpdateNotice">Customer accounts can only be edited by the customer themselves.</p>
          </AdminCard>
        ) : (
          <AdminCard className="userUpdate">
            <span className="userUpdateTitle">Edit</span>
            <form onSubmit={handleSubmit}>
              <AdminInput label="First Name" name="first_Name" value={data.first_Name || ""} onChange={handleChange} error={server_error.first_Name?.[0]} />
              <AdminInput label="Last Name" name="last_Name" value={data.last_Name || ""} onChange={handleChange} error={server_error.last_Name?.[0]} />
              <AdminInput label="Phone Number" name="phone_Number" value={data.phone_Number || ""} onChange={handleChange} error={server_error.phone_Number?.[0]} />
              <AdminInput label="House Number" name="house_Number" value={data.house_Number || ""} onChange={handleChange} />
              <AdminInput label="Street Number" name="street_Number" value={data.street_Number || ""} onChange={handleChange} />
              <AdminInput label="Area" name="area" value={data.area || ""} onChange={handleChange} />
              <AdminSelect label="City" name="city" value={data.city || ""} onChange={handleChange}>
                <option value="Chennai">Chennai</option>
                <option value="Coimbatore">Coimbatore</option>
              </AdminSelect>
              <div className="userUpdateActions">
                <LoadingButton type="submit" loading={isLoading} loadingLabel="Saving...">Update</LoadingButton>
              </div>
            </form>
          </AdminCard>
        )}
      </div>
    </div>
  );
}

export default CustomerEdit
